import { render } from "./MessageBubble.vue?vue&type=template&id=4954cad8&ts=true"
import script from "./MessageBubble.vue?vue&type=script&lang=ts"
export * from "./MessageBubble.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./MessageBubble.vue?vue&type=style&index=0&id=4954cad8&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__